import StructuredContent from '@nerdwallet/structured-content-core';
import P from 'prop-types';

export const insuranceButtonTypes = {
  HOME_INSURANCE: 'HomeInsuranceEntryPointForm',
  AUTO_INSURANCE: 'AutoInsuranceEntryPointForm',
};

const InsuranceButton = ({
  type,
  isInternal,
  buttonText,
  defaultZipCode,
  buttonAnnotation,
  pricingCode,
  disablePopback,
}) => {
  return (
    <StructuredContent>
      {{
        type: 'Container',
        version: '1.0.0',
        props: {
          children: [
            {
              type,
              version: '1.0.0',
              props: {
                disablePopback,
                isInternal,
                buttonText,
                buttonAnnotation,
                defaultZipCode,
                pricingCode,
              },
            },
          ],
        },
      }}
    </StructuredContent>
  );
};

InsuranceButton.propTypes = {
  type: P.oneOf(Object.values(insuranceButtonTypes)),
  isInternal: P.bool,
  buttonText: P.string,
  defaultZipCode: P.string,
  buttonAnnotation: P.string,
  pricingCode: P.string,
  disablePopback: P.bool,
};

InsuranceButton.defaultValues = {
  type: insuranceButtonTypes.AUTO_INSURANCE,
  isInternal: false,
  disablePopback: false,
};

export default InsuranceButton;
